import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      text: 'SSL Encrypted'
    },
    {
      icon: 'Lock',
      text: 'Secure Authentication'
    },
    {
      icon: 'Eye',
      text: 'Privacy Protected'
    }
  ];

  const testimonials = [
    {
      company: "Luxury Gems Co.",
      quote: "JewelThread has transformed how we share designs with our high-end clients.",
      author: "Sarah Chen, Owner"
    },
    {
      company: "Diamond District",
      quote: "The security features give us complete confidence in protecting our designs.",
      author: "Michael Rodriguez, Designer"
    }
  ];

  return (
    <div className="space-y-8">
      {/* Security Features */}
      <div className="flex justify-center space-x-8">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-2">
            <Icon 
              name={feature?.icon} 
              size={16} 
              color="var(--color-success)" 
            />
            <span className="text-xs text-muted-foreground font-medium">
              {feature?.text}
            </span>
          </div>
        ))}
      </div>
      {/* Trust Badges */}
      <div className="flex justify-center space-x-6">
        <div className="flex items-center space-x-2 px-3 py-2 bg-muted/50 rounded-lg">
          <Icon name="Award" size={14} color="var(--color-accent)" />
          <span className="text-xs text-muted-foreground font-medium">
            Industry Certified
          </span>
        </div>
        <div className="flex items-center space-x-2 px-3 py-2 bg-muted/50 rounded-lg">
          <Icon name="Users" size={14} color="var(--color-accent)" />
          <span className="text-xs text-muted-foreground font-medium">
            500+ Jewelers
          </span>
        </div>
      </div>
      {/* Testimonials */}
      <div className="space-y-4">
        {testimonials?.map((testimonial, index) => (
          <div key={index} className="text-center p-4 bg-muted/30 rounded-lg">
            <p className="text-sm text-muted-foreground italic mb-2">
              "{testimonial?.quote}"
            </p>
            <div className="flex items-center justify-center space-x-2">
              <span className="text-xs font-medium text-foreground">
                {testimonial?.author}
              </span>
              <span className="text-xs text-muted-foreground">
                • {testimonial?.company}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustIndicators;